import { FieldTypeENUM, IDynamicForm } from '../models';

export const DEFAULT_FG: IDynamicForm = {
  id: null,
  title: null,
  description: null,
  sections: [
    {
      id: 'section_0',
      title: null,
      description: null,
      fields: [
        {
          id: 'section_0_field_0',
          label: null,
          type: FieldTypeENUM.SELECT,
          value: null,
          required: false,
        },
      ],
    },
  ],
};
